import { LuCkEditorToolBar } from '../../lu-ckeditor.models';

export const postCommentsToolbar: LuCkEditorToolBar[] = [
	{
		name: 'clipboard',
		items: ['Undo', 'Redo']
	},
	{
		name: 'basicstyles',
		items: ['Bold', 'Italic', 'Underline', '-', 'Link', 'Unlink', '-', 'Subscript', 'Superscript']
	}
];
